import {
    Button,
    Box,
    Stack,
} from "@mui/material";

import { CardElement } from "@stripe/react-stripe-js";

interface Props {
    cardComplete: boolean;
    onCardComplete: (
        complete: boolean
    ) => void;

    onAddCard: () => void;
    onBack: () => void;

    showBackButton: boolean;
}

export default function AddCardForm({
    cardComplete,
    onCardComplete,
    onAddCard,
    onBack,
    showBackButton,
}: Props) {
    return (
        <>
            <Box
                sx={{
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                    p: 2,
                    mb: 2,
                }}
            >
                <CardElement
                    options={{
                        hidePostalCode: true,
                    }}
                    onChange={(event) =>
                        onCardComplete(
                            event.complete
                        )
                    }
                />
            </Box>

            <Stack spacing={2}>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={onAddCard}
                    disabled={!cardComplete}
                >
                    Add Card
                </Button>

                {showBackButton && (
                    <Button
                        fullWidth
                        variant="outlined"
                        onClick={onBack}
                    >
                        Back
                    </Button>
                )}
            </Stack>
        </>
    );
}